import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import type { Observable } from 'rxjs';

import { IntegrationsClientConfig, IntegrationsCredentials } from '@recruitee/integrations-types';

@Injectable()
export abstract class IntegrationsClientHttpBase {
  constructor(
    private http: HttpClient,
    protected config: IntegrationsClientConfig,
    protected integrationsCredentials: IntegrationsCredentials,
  ) {}

  public abstract get baseUrl(): string;

  public get<T = any>(path: string): Observable<T> {
    return <Observable<any>>this.http.get(`${this.baseUrl}/${path}`, this.httpOptions());
  }

  public post<T = any>(path: string, body: any): Observable<T> {
    return <Observable<any>>this.http.post(`${this.baseUrl}/${path}`, body, this.httpOptions());
  }

  public patch<T = any>(path: string, body: any): Observable<T> {
    return <Observable<any>>this.http.patch(`${this.baseUrl}/${path}`, body, this.httpOptions());
  }

  public delete<T = any>(path: string): Observable<T> {
    return <Observable<any>>this.http.delete(`${this.baseUrl}/${path}`, this.httpOptions());
  }

  protected httpOptions(): { headers: { [name: string]: string } } {
    return {
      headers: {
        'X-JSON-Accent': 'pascal',
        Authorization: `Bearer ${this.integrationsCredentials.accessToken}`,
      },
    };
  }
}
